import FootballState from "../state/football-state";

export default class PlayRequiresState extends Error {
    constructor(state) {
        const stateName =
            Object.keys(FootballState)[
                Object.values(FootballState).findIndex((e) => e === state)
            ];
        super(`Play must contain the following state: ${stateName}`);
    }
}
